/**
 * 文字链
 */
import reqwest from 'reqwest'
const url = 'https://guess.union2.50bang.org/home.php/AdsApi_BrowserErrorPage'
export default {
  /**
   * 获取文字链数据
   * @param params
   * @param callback
   */
  getWordLinksList (params, callback) {
    reqwest({
      url: url,
      data: params,
      type: 'jsonp',
      jsonpCallback: 'jsonp',
      timeout: 3000
    })
    .then(val => callback(null, val))
    .catch(e => callback(e))
  },
  /**
   * 发送ajax统计
   * @param vUrl
   * @param ggid
   * @param index
   * @param channel
   * @param startTime
   */
  ajax131 (vUrl, ggid, index, channel, startTime) { // 猜你喜欢点击统计，vUrl：广告地址md5，ggid：广告id
    if (typeof channel === 'undefined' || channel === '') {
      channel = 'cu1000181'
    }
    var time = (new Date() - 0) - startTime
    var e = event || window.event
    var obj = document.elementFromPoint(e.clientX, e.clientY).offsetParent
    var url = '//web.50bangzh.com/web/ajax131?uId2=SPTNPQRLSX&i=' +
      channel + '&e=0&r=' + encodeURIComponent(document.location.href) +
      '&f=' + screen.width + '*' + screen.height + '&lO=' + encodeURIComponent(vUrl) +
      '&l=' + ggid + '&d=' + index + '&m=' + time + '&s=' + e.screenX + '*' + e.screenY +
      '&p=' + obj.offsetLeft + '*' + obj.offsetTop
    var _dh = document.createElement('script')
    _dh.setAttribute('type', 'text/javascript')
    _dh.setAttribute('src', url)
    _dh.onload = function () {
      _dh.remove()
    }
    document.getElementsByTagName('head')[0].appendChild(_dh)
  },
  /**
   * 发送ajax统计
   * @param ggidStr
   * @param flidInfo
   * @param channel
   */
  ajax132 (ggidStr, flidInfo, channel) { // 猜你喜欢展现统计,vUrl：广告地址md5，ggid：广告id
    if (typeof channel === 'undefined' || channel === '') {
      channel = 'cu1000181'
    }
    var f = 1
    var url = '//web.50bangzh.com/web/ajax132?uId2=SPTNPQRLSX&i=' + channel +
      '&r=' + encodeURIComponent(document.location.href) + '&lO=' +
      encodeURIComponent(ggidStr) + '&c=' + flidInfo + '&e=0&l=0' + '&f=' + f
    var _dh = document.createElement('script')
    _dh.setAttribute('type', 'text/javascript')
    _dh.setAttribute('src', url)
    _dh.onload = function () {
      _dh.remove()
    }
    document.getElementsByTagName('head')[0].appendChild(_dh)
  }
}
